import { ceilPrice } from '~/utils/Utils'

const usePrices = () => {
  const totalPrice = (gesamtpreis: string|null): string|null => {
    if (gesamtpreis) {
      return ceilPrice(gesamtpreis)
    }
    return null
  }

  const totalPriceOriginal = (
    gesamtpreisOriginal: string|null,
    gesamtpreis: string|null
  ): string|null => {
    const originalPrice = gesamtpreisOriginal ?? 0
    const discountedPrice = gesamtpreis ?? 0
    if (!originalPrice || !discountedPrice) {
      return null
    }
    if (originalPrice <= discountedPrice) {
      return null
    }
    return ceilPrice(originalPrice)
  }

  const totalPriceDiscountPercentage = (
    gesamtpreisOriginal: string|null,
    gesamtpreis: string|null
  ): string|null => {
    const originalPrice = gesamtpreisOriginal ?? 0
    const discountedPrice = gesamtpreis ?? 0
    if (!originalPrice || !discountedPrice) {
      return null
    }
    if (originalPrice <= discountedPrice) {
      return null
    }
    return Math.round(((originalPrice - discountedPrice) / originalPrice) * 100)
  }

  const pricePerNight = (
    min: string|null,
    lastminuteTagespreis: string|null
  ): string|null => {
    if (min) {
      return ceilPrice(min)
    }
    if (lastminuteTagespreis) {
      return ceilPrice(lastminuteTagespreis)
    }
    return null
  }

  return {
    totalPrice,
    totalPriceOriginal,
    totalPriceDiscountPercentage,
    pricePerNight
  }
}

export default usePrices
